/** Static chunking strategy labels — not sample data. */
export const chunkingStrategies = [
  { id: "fixed", name: "Fixed-size", description: "Split into fixed-token chunks with overlap" },
  { id: "recursive", name: "Recursive", description: "Split recursively on separators, falling back to size" },
  { id: "semantic", name: "Semantic", description: "Cluster sentences by embedding similarity" },
  { id: "md", name: "Markdown-aware", description: "Honor markdown headings and code fences" },
  { id: "struct", name: "Document-structure", description: "Use document outline (headings, tables, lists)" },
];
